import {
  Card,
  CardContent,
  CardMedia,
} from '@mui/material';
import TextLines from '../../../text/TextLines';
import MediaPlayer from '../../../media/MediaPlayer';
import { getPageStyle } from '../../common/LessonPageUtil';
import './MatchingResponse.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  responseCard: {},
};

/**
 * Matching responses
 */
export default function MatchingResponse(p) {
  const {
    responseCard,
    index,
    cardId,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <Card
      className='matching-component-card'
      style={getPageStyle(responseCard, true)}
    >
      {
        responseCard.image ? (
          <CardMedia
            className='matching-component-image'
            image={responseCard.image}
            title='Matching'
          />
        ) : ''
      }
      {responseCard.text
        ? (
          <CardContent className='matching-component-text'>

            <TextLines textLines={responseCard.text} />

          </CardContent>
        ) : ''}
      {
        (responseCard.audio || responseCard.video)
        && (
          <MediaPlayer
            audioUrl={responseCard.audio}
            videoUrl={responseCard.video}
            parentElementId={cardId}
            className={`vizzle-matching-responses-page-${index}-media-btn`}
          />
        )
      }
    </Card>
  );
}
